export enum OrderOperationTypeForQuery {
  SecuritiesPurchase = 'securities_purchase',
  SecuritiesSale = 'securities_sale',
  SecuritiesWithdrawal = 'securities_withdrawal',
  SecuritiesDeposit = 'securities_deposit',
}
